<style>


</style>

<template>

<div class="c-application">
    
    <core-ajax :src="dataAdminSrc" @on:success="onDataAdminSuccess" @on:error="onDataError"></core-ajax>
    <!--<core-ajax :src="dataAdminSrcfr" @on:success="onDataAdminSuccessfr" @on:error="onDataError"></core-ajax>
    <core-ajax :src="dataAdminSrcde" @on:success="onDataAdminSuccessde" @on:error="onDataError"></core-ajax>-->
    <app-header  :content="globalContent"  :color="headerColor">  </app-header>
    <component   v-if="isDataAdminLoaded"  :isPopinActive="isPopinActive"  :isActive="isSubsidiariesActive"    :is="componentId"  :isLoaderActive="isLoaderActive"  :headerPageSize="headerPageSize"  :adminContent="adminContent"  :globalContent="globalContent" ></component>
    <app-burger   :color="headerColor"></app-burger>
    <app-nav  :content="globalContent"    :isActive= "isNavActive"   :activePageIndex="pageIndex" :activePageIndexSub="pageIndexSub" ></app-nav>
    <app-loader   :isActive="isLoaderActive"></app-loader>
    <app-loader-intro   :assets="globalContent.assetsToLoad"  :headerPageSize="headerPageSize"></app-loader-intro>
    <!--<app-footer-one :color="bottomColor"  :mainLogoVisible="!0"></app-footer-one>-->
</div>

</template>

<script>

import Vue from 'vue'
import router from './router.js'

import {getAbsoluteBoundingRect}  from '../utilities/getAbsoluteBoundingRect.js'
import eventHub from '../mixins/eventHub'
import CoreAjax from '../components/core-ajax/index.vue'
import AppHeader from '../components/app-header/index.vue'
import AppBurger from '../components/app-burger/index.vue'
import AppNav from '../components/app-nav/index.vue'

import AppLoader from '../components/app-loader/index.vue'
import AppLoaderIntro from '../components/app-loader-intro/index.vue'
import appPageHome from '../components/app-page-home/index.vue'



import  appPageSectors from '../components/app-page-sectors/index.vue'

import  appPageNews from '../components/app-page-news/index.vue'
import  appPage404 from '../components/app-page-news/index.vue'
import  appPageContact  from '../components/app-page-contact/index.vue'

import  appPageInnovations from '../components/app-page-innovation/index.vue'

import  appPageArticles  from '../components/app-page-article/index.vue'
import  appPageArticlesInnovations  from '../components/app-page-articleinnovations/index.vue'

import  appPageNavalVessels from '../components/app-page-navalvessel/index.vue'

import  appPageCommercialVessels  from '../components/app-page-commercial/index.vue'
import  appPageEquipment from '../components/app-page-equipment/index.vue'
import  appPageSupperyacht from '../components/app-page-supperyacht/index.vue'
import  appPageCompanyProfile from '../components/app-page-companyprofile/index.vue'

import appPageQualityPolicy from '../components/app-page-qualitypolicy/index.vue'

import appPageOperations from '../components/app-page-operations/index.vue'

import appPageOccupationalhealth from '../components/app-occupational-health/index.vue'

import appPageOrganizationalstructure from '../components/app-organizational-structure/index.vue'




import VTooltip from 'v-tooltip'
//import {VueSlideoutPanel} from '../vueslideout/index'
//import VueCarousel from 'vue-carousel';

//import AppFormBuyCar from '../components/app-form-buycar/index.vue'
//import AppFormSellCar from '../components/app-form-sellcar/index.vue'
import appFooterone from '../components/app-footer1/index.vue'



//Vue.component('slideout-panel', VueSlideoutPanel)
//Vue.component('app-form-buycar', AppFormBuyCar)
//Vue.component('app-form-sellcar', AppFormSellCar)
//Vue.use(VueCarousel);
let _globalContent = require("./global.json")
//let _globalContenten = require("./global.json")
//let _globalContentfr = require("./globalfr.json")
//let _globalContentde = require("./globalde.json")

import '../assets/css/ucss.css'
import '../assets/css/cssrgh.css'
import { log } from 'util'

Vue.use(VTooltip)

Vue.config.productionTip = false


//Vue.prototype.eventHub = new Vue();


export default {
    router,
   name: "",
    props: {
      debug: {
          type: Boolean,
          default: !1
      },
    },
        components: {
          "core-ajax":CoreAjax,
          "app-header":AppHeader,
          "app-burger":AppBurger,
          "app-loader":AppLoader,
          "app-nav":AppNav,
          "app-loader":AppLoader,
          "app-loader-intro":AppLoaderIntro,
          "app-footer-one":appFooterone,
          appPageQualityPolicy,
          appPageOccupationalhealth,
          appPageOperations,
          appPageOrganizationalstructure,
          appPageHome,
          appPageSectors,
          appPageNews,
          appPageArticles,
          appPage404,
          appPageContact,
          appPageSupperyacht,
          appPageNavalVessels,
          appPageCommercialVessels,
          appPageEquipment,
         
          appPageInnovations,
          appPageArticlesInnovations,
          appPageCompanyProfile
        },
        data: function() {
            return {
                lang:'en',
                adminContent: null,
                adminContentfr: null,
                adminContenten: null,
                globalContent:_globalContent,
                globalContenten:_globalContent,
                globalContentfr:_globalContent,
                globalContentde:_globalContent,
                componentId: null,
                dataAdminSrc: document.body.getAttribute("data-url"),
                dataAdminSrcfr: document.body.getAttribute("datafr-url"),
                dataAdminSrcde: document.body.getAttribute("datade-url"),
                headerColor: "clear",
                bottomColor: "clear",
                bottomColorForced: !1,
                headerColorForced: !1,
                homeSlideIndex: 0,
                isDataAdminLoaded: !1,
                isLoaderActive: !0,
                isFirstLoading: !0,
                isHeaderHided: !1,
                isScrollDisabled: !1,
                winWidth: 0,
                winHeight: 0,
                scrollTop: 0,
                smoothScroll: 0,
                isTouch: 0,
                isSubsidiariesActive: !1,
                isNavActive: !1,
                pageIndex: 0,
                pageIndexSub: 0,
                isPopinActive: !1,
                headerPageSize: [0, 0, 0, 0, 0],
                isIE: document.documentMode || /Edge/.test(navigator.userAgent)
            }
        },
        watch: {

            $route: "onRouteChange"
        },
        created: function()
        {
                this.debug&&console.log("call method Cycle Create methode main application");
                
                window.addEventListener("resize", this.onResize.bind(this)),
                document.addEventListener("scroll", this.onScroll.bind(this)),
                this.$body = document.body,
                this.$HomeSliderRightNav = document.querySelector(".c-home__nav"),
                this._isClosing = !1,
                this.eventHub.$on("toggle:nav", this.onToggleNav.bind(this)),
                this.eventHub.$on("page:ready", this.onPageReady.bind(this)),

                this.eventHub.$on("page:readynscroll", this.onPageReadyNoScroll.bind(this)),

                this.eventHub.$on("hide:header", this.onHideHeader),
                this.eventHub.$on("show:header", this.onShowHeader.bind(this)),
                //this.eventHub.$on("change:slide", this.onChangeSlide),
                this.eventHub.$on("close:popin", this.onClosePopin.bind(this)),
                this.eventHub.$on("open:popin", this.onOpenPopin.bind(this)),
                this.eventHub.$on("open:popinphotos", this.onOpenPopinPhotos.bind(this)),
                this.eventHub.$on("close:popinphotos", this.onClosePopinPhotos.bind(this)),



                this.eventHub.$on("close:popinslideout", this.onClosePopinSlideOutH.bind(this)),
                this.eventHub.$on("open:popinslideout", this.onOpenPopinSlideOutH.bind(this)),

                this.eventHub.$on("disable:scroll", this.onDisableScroll.bind(this)),
                this.eventHub.$on("enable:scroll", this.onEnableScroll.bind(this)),
                this.eventHub.$on("assets:loaded", this.onAssetsLoaded.bind(this)),
                this.eventHub.$on("set:headerPageSize", this.onSetHeaderPageSize.bind(this))
        },
        mounted: function()
        {
          this.debug&&console.log("call method Cycle After Load ajax mount main application");
          this.lang=this.$route.params.lang;
          this.onRouteChange(this.$route),
                this.onResize(),
                this.onEnterFrame()
        },
        methods:
        {

          onDataAdminSuccess: function(t) {
            this.debug&&console.log("call method Cycle Load Ajax Emitt Success event assign adminContent");
              this.isDataAdminLoaded = !0,
                  this.adminContenten = t.body,
                  this.adminContent = t.body

          },
           onDataAdminSuccessfr: function(t) {
            this.debug&&console.log("call method Cycle Load Ajax Emitt Success event assign adminContent");
              this.isDataAdminLoaded = !0,
                  this.adminContentfr = t.body

          },
            onDataAdminSuccessde: function(t) {
            this.debug&&console.log("call method Cycle Load Ajax Emitt Success event assign adminContent");
              this.isDataAdminLoaded = !0,
                  this.adminContentde = t.body

          },
          onSetHeaderPageSize: function (t, e, n, r, s)
          {
              Vue.set(this.headerPageSize, 0, t),
              Vue.set(this.headerPageSize, 1, e),
              Vue.set(this.headerPageSize, 2, n),
              Vue.set(this.headerPageSize, 3, r),
              Vue.set(this.headerPageSize, 4, s)
          },
          showSimpleLoader: function()
          {
              this.$el.classList.add("is-loading")
          },
          onToggleNav: function ()
          {
              this.isNavActive = !this.isNavActive;
              if("subsidiaries" === this.$route.name)
              this.isSubsidiariesActive=!this.isSubsidiariesActive;
              this.isNavActive ? this.$el.classList.add("is-nav-active") : (this._isClosing = !0, this.$el.classList.remove("is-nav-active"), this.onEnableScroll())
          },
          showLoader: function() {
              this.isLoaderActive = !0,
                  this.$el.classList.add("is-loading")
          },
          hideLoader: function() {
              this.isLoaderActive = !1,
                  this.$el.classList.remove("is-loading"),
                  this.$el.classList.remove("is-first-loading")
          },
          onHideHeader: function() {

              this.$el.classList.add("is-header-fixed"),
              this.isHeaderHided = !0
          },
          onShowHeader: function()
          {
             this.debug&&console.log("where is my my heade")
              this.$el.classList.remove("is-header-fixed"),
               this.isHeaderHided = !1
          },
          onPageReady: function(e) {
              this.debug&&console.log("call method Cycle onPageReady");
              var t = this;
              if (!this.isFirstLoading)
              {
                  this.debug&&console.log("call method Cycle onPageReady isFirstLoading");
                  this._isClosing = !1,
                      this.$headerPanels = this.$el.querySelectorAll(".js-header-panel"),
                        this.debug&&console.log("call method Cycle onPageReady inside Rad"+this.$headerPanels);
                      this._headerPanelArr = new Array(),
                      setTimeout(function() {
                            this.debug&&console.log("call method Cycle onPageReady inside Rad");
                          for (var e = 0; e < t.$headerPanels.length; e++)
                           t._headerPanelArr.push({
                              y: 0,
                              height: 0,
                              activeColor: t.$headerPanels[e].getAttribute("data-color")
                          });
                          t.onResize(),
                          t.hideLoader(),
                           t.onEnableScroll()
                      }, 500)
                      switch(e)
                      {
                        case 'fr':{
                          router.push({ name: 'home', params: { lang: 'fr'} })
                        } break;
                        case 'de':{
                          router.push({ name: 'home', params: { lang: 'de'} })
                        } break;
                      }
                      
              }
          },
          onPageReadyNoScroll: function()
          {
              this.debug&&console.log("call method Cycle onPageReady");
              var t = this;
              if (!this.isFirstLoading)
              {
                      this.debug&&console.log("call method Cycle onPageReady isFirstLoading");
                      this._isClosing = !1,
                      this.$headerPanels = this.$el.querySelectorAll(".js-header-panel"),
                      this.debug&&console.log("call method Cycle onPageReady inside Rad"+this.$headerPanels);
                      this._headerPanelArr = new Array(),
                      setTimeout(function() {
                            this.debug&&console.log("call method Cycle onPageReady inside Rad");
                          for (var e = 0; e < t.$headerPanels.length; e++)
                           t._headerPanelArr.push({
                              y: 0,
                              height: 0,
                              activeColor: t.$headerPanels[e].getAttribute("data-color")
                          });
                          t.onResize(),
                          t.hideLoader()
                      }, 500)
              }
          },
          onAssetsLoaded: function(e) {
              
              this.debug&&console.log("call method Cycle onPageReady On Assets Loading");
              this.isFirstLoading = !1,
              this.onPageReady('en')
          },
          onDataError: function(t) {
              this.debug&&console.warn("error loading ajax:", t)
          },
            onRouteChange: function(t, e) {

              this.headerColor=t.meta.headerColor;
              this.lang=this.$route.params.lang;
              
              switch(this.lang)
              {
                case "fr":{
                  this.adminContent=this.adminContentfr;
                  if(typeof(this.globalContentfr)!='undefined')
                  this.globalContent=this.globalContentfr
                } break;
                case "en":{
                  this.adminContent=this.adminContenten;
                 
                  if(typeof(this.globalContenten)!='undefined')
                  this.globalContent=this.globalContenten
                } break;
                case "de":{
                  this.adminContent=this.adminContentde;
                  if(typeof(this.globalContentde)!='undefined')
                  this.globalContent=this.globalContentde
                } break;
                default: {
                  this.adminContent=this.adminContenten;
                  if(typeof(this.globalContenten)!='undefined')
                  this.globalContent=this.globalContenten
                }
              }
              
              //////////
              if(("subsidiaries" === this.$route.name)&&!this.isNavActive)
              {
                this.isSubsidiariesActive=!1;
              }
              if(("subsidiaries" === this.$route.name))
              {
                this.isSubsidiariesActive=!0;
              }
              if(("subsidiaries" === this.$route.name)&&this.isNavActive)
              {
                this.isSubsidiariesActive=!1;
              }
              //  console.log("headerColor:"+this.headerColor);
                this.debug&&console.log("call method Cycle onRouteChange");
                var n = this;
                clearTimeout(r),
                    this.isNavActive || this._isClosing ? (this.onDisableScroll(), this.showSimpleLoader()) : (this.showLoader(), this.onDisableScroll()),
                    void 0 != e && this.$el.classList.remove("is-" + e.name),
                     this.$el.classList.add("is-" + t.name),
                     void 0 == e && this.$el.classList.add("is-first-loading"),
                      void 0 == e && "home" === this.$route.name ? this.$el.classList.add("is-first-home") : this.$el.classList.remove("is-first-home");
                var r = setTimeout(function() {
                    window.scrollTo(0, 0),
                    n.scrollTop = 0,
                    n.smoothScroll = 0,
                    n.componentId = null,
                    requestAnimationFrame(function() {
                        n.componentId = t.meta.component
                    }),
                    n.onShowHeader(),
                    n.headerColor = t.meta.headerColor,
                    n.pageIndex = t.meta.index,
                    n.pageIndexSub=t.meta.indexsub,
                    document.title = t.meta.title,
                    document.querySelector("meta[name='description']").setAttribute('content',t.meta.Description)
                    document.querySelector("meta[name='keywords']").setAttribute('content',t.meta.Keywords)
                }, 450)
                this.changeHeaderColor(this.headerColor),
                this.debug&&console.log("headerColor:"+this.headerColor);
            },
            showLoader: function()
            {
                        this.isLoaderActive = !0,
                        this.$el.classList.add("is-loading")
            },

            onResize: function()
            {
              this.debug&&console.log("call root resize");
                this.winWidth = window.innerWidth,
                    this.winHeight = window.innerHeight;
                if (this._headerPanelArr) {
                    for (var t = 0; t < this._headerPanelArr.length; t++)
                     {
                            this._headerPanelArr[t].y = getAbsoluteBoundingRect(this.$headerPanels[t]).top - 60,
                            this._headerPanelArr[t].height = this.$headerPanels[t].offsetHeight
                    }
                }
                  this.debug&&console.log("End it call root resize");
                  this.eventHub.$emit("resize")
            },
            onScroll: function(t)
            {

                       this.scrollTop = window.pageYOffset || document.documentElement.scrollTop
            },
            onEnterFrame: function()
            {
                //console.log("this.smoothScroll="+this.smoothScroll);
                this.smoothScroll = this.scrollTop;
                if (this._headerPanelArr && "terms-and-conditions" !== this.$route.name && !this.isPopinActive)
                {
                  if(this._headerPanelArr!=null){
                    for (var t = 0; t < this._headerPanelArr.length; t++)
                    {
                     this.smoothScroll > this._headerPanelArr[t].y && null != this._headerPanelArr[t + 1] && this.smoothScroll < this._headerPanelArr[t + 1].y
                     ?
                      (
                      this.headerColor !== this._headerPanelArr[t].activeColor && this.changeHeaderColor(this._headerPanelArr[t].activeColor))
                       :
                       this.smoothScroll > this._headerPanelArr[t].y && null == this._headerPanelArr[t + 1] && this.headerColor !== this._headerPanelArr[t].activeColor && this.changeHeaderColor(this._headerPanelArr[t].activeColor);

                       ////Bottom//////
                    if(this._headerPanelArr[t + 1]!=null)
                    {
                              if(this.smoothScroll > this._headerPanelArr[t].y &&this.smoothScroll < 10&& null != this._headerPanelArr[t + 1] && this.smoothScroll < this._headerPanelArr[t + 1].y)
                              {
                                this.bottomColor!= this._headerPanelArr[t].activeColor && this.changeBottomColor(this._headerPanelArr[t].activeColor)
                              }
                              this.smoothScroll > this._headerPanelArr[t].y &&this.smoothScroll > 10&& null != this._headerPanelArr[t + 1] && this.smoothScroll < this._headerPanelArr[t + 1].y
                              ?
                               (

                             
                                this.bottomColor!= this._headerPanelArr[t+1].activeColor && this.changeBottomColor(this._headerPanelArr[t+1].activeColor)
                               )
                                :
                                (this.smoothScroll > this._headerPanelArr[t].y && null == this._headerPanelArr[t + 1] && this.bottomColor !== this._headerPanelArr[t].activeColor && this.changeBottomColor(this._headerPanelArr[t].activeColor));
                    }
                    /////////////////////////////
                    }
                    }

                   }
                "terms-and-conditions" !== this.$route.name  && (this.smoothScroll > 250 && !this.isHeaderHided
                  ?
                  this.onHideHeader()
                   :
                   this.smoothScroll < 250 && this.isHeaderHided && !this.isPopinActive && this.onShowHeader()),
                   this.eventHub.$emit("enterframe"),
                   window.requestAnimationFrame(this.onEnterFrame)
            },
            onDisableScroll: function() {
              this.$body.classList.add("u-overflow-h")
          },
          onEnableScroll: function() {
              this.$body.classList.remove("u-overflow-h")
          },
          onChangeSlide: function(t)
          {
              this.homeSlideIndex = t
          },
          changeBottomColor: function(t)
          {
              this.bottomColor = t
          },
          changeHeaderColor: function(t)
          {
                       this.headerColor = t
                       if(this.$route.name=="home")
                       {

                         var elimnt=this.$el.querySelectorAll(".c-home__nav__dot");
                         if(t!="dark"&&t!="clear")
                         {
                         for (var ell = 0; ell < elimnt.length; ell++)
                         {
                             elimnt[ell].classList.remove("u-bg--black")
                             elimnt[ell].classList.add("u-bg--white")

                         }
                         }
                          if(t=="dark")
                          {

                            for (var ell = 0; ell < elimnt.length; ell++)
                            {
                                elimnt[ell].classList.remove("u-bg--white")
                                elimnt[ell].classList.add("u-bg--black")
                            }

                          }
                          if(t=="clear")
                          {
                            for (var ell = 0; ell < elimnt.length; ell++)
                            {
                                elimnt[ell].classList.remove("u-bg--black")
                                elimnt[ell].classList.add("u-bg--white")

                            }
                          }
                       }
                   },

                   onOpenPopinSlideOutH: function()
                    {

                      var n = this;
                       this.popinIndexSlideOut = 0,
                       this.changeHeaderColor("dark"),
                       setTimeout(function ()
                       {
                              n.$el.classList.add("is-popin-active"),
                              n.isPopinActive = !0
                       }, 50)
                    },
                    onClosePopinSlideOutH: function ()
                    {

                        this.isPopinActive = !1,
                        this.eventHub.$emit('close:Panel');
                        this.$el.classList.remove("is-popin-active")

                    },
                   onOpenPopin: function()
                    {

                        this.$el.classList.add("is-popin-active"),
                        this.isPopinActive = !0,
                        this.changeHeaderColor("dark"),

                        this.eventHub.$emit("enable:scroll"),

                        "home" === this.$route.name ? (
                          this.$HomeSliderRightNav =  Array.from(document.querySelectorAll(".c-home__nav")),

                        this.$HomeSliderRightNav.forEach(function(navBlock) {
                              navBlock.classList.add("NavWhenpopin-zindex--0")
                                                                                                          })
                      ) : "";
                    }
                    ,
                    onOpenPopinPhotos: function()
                    {
                        
                        this.$el.classList.add("is-popin-active--photos"),
                        this.isPopinActive = !0,
                        this.changeHeaderColor("dark"),

                        this.eventHub.$emit("enable:scroll"),

                        "home" === this.$route.name ? (
                          this.$HomeSliderRightNav =  Array.from(document.querySelectorAll(".c-home__nav")),

                        this.$HomeSliderRightNav.forEach(function(navBlock) {
                              navBlock.classList.add("NavWhenpopin-zindex--0")
                                                                                                          })
                      ) : "";
                    }
                    ,
                    onClosePopin: function ()
                    {

                        var t = this;
                        if(document.getElementById("c-team-popin__photo")!=null)
                        document.getElementById("c-team-popin__photo").src = "/static/subsidiaries/anim-load-subsidiaries.gif"

                        this.isPopinActive = !1,
                          "home" === this.$route.name ?(
                            this.$HomeSliderRightNav =  Array.from(document.querySelectorAll(".c-home__nav")),
                            this.$HomeSliderRightNav.forEach(function(navBlock) {
                                navBlock.classList.remove("NavWhenpopin-zindex--0")
                                                                                                            })
                        ): "",
                        this.$el.classList.remove("is-popin-active"),
                          this.changeHeaderColor("clear")
                        setTimeout(function() {
                            t.onResize()
                        }, 1050)
                    },
                    onClosePopinPhotos: function ()
                    {

                        var t = this;
                        if(document.getElementById("c-team-popin__photo")!=null)
                        document.getElementById("c-team-popin__photo").src = "/static/subsidiaries/anim-load-subsidiaries.gif"

                        this.isPopinActive = !1,
                          "home" === this.$route.name ?(
                            this.$HomeSliderRightNav =  Array.from(document.querySelectorAll(".c-home__nav")),
                            this.$HomeSliderRightNav.forEach(function(navBlock) {
                                navBlock.classList.remove("NavWhenpopin-zindex--0")
                                                                                                            })
                        ): "",
                        this.$el.classList.remove("is-popin-active--photos"),
                          this.changeHeaderColor("clear")
                        setTimeout(function() {
                            t.onResize()
                        }, 1050)
                    }
        }
}

</script>
